import { isEmpty } from 'lodash';

export const getEmojiFromUnicode = (emojiId: string) => {
  if (!isEmpty(emojiId)) {
    const emojiChar = emojiId
      .split('-')
      .map((code) => String.fromCodePoint(parseInt(code, 16)))
      .join('');
    return emojiChar;
  }
  return '';
};

export const getUnicodeFromEmoji = (emoji: string) => {
  return Array.from(emoji)
    .map((char) => char.codePointAt(0)?.toString(16))
    .filter(Boolean)
    .join('-');
};

const isUnifiedId = (id: string) => /^[a-f0-9-]+$/.test(id); // Allow '-' for multi-codepoint emojis

const isValidUnifiedId = (unifiedId: string) => isNaN(Number(unifiedId));

export const getValidUnifiedId = (emojiId: string) => {
  return isUnifiedId(emojiId) && isValidUnifiedId(emojiId)
    ? emojiId
    : isValidUnifiedId(getUnicodeFromEmoji(emojiId))
      ? getUnicodeFromEmoji(emojiId)
      : '';
};
